export default "__VITE_ASSET__GcBWLkSN__"